<script>
  export let url;
</script>

<img class="results__img" src="{url}" alt="auto" />

<style lang="scss">
  .results {
    &__img {
      width: 70px;
      border-radius: 10px;
      margin-right: 10px;
    }
  }
</style>